import { FunctionComponent, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useComputedTabWidth, useComputedLeftOffset, useComputedLinePos } from './context';
import animate from '@/utils/Animate';

interface FixedNavProps {
    options: Optionstype[];
    active: string;
    onChange: (value: string) => void;
    lookPosition?: boolean;
}
type Optionstype = {
    id: string;
    name: string;
    desc: string;
};

const FixedNav: FunctionComponent<FixedNavProps> = (props) => {
    const { contentRef, chooseTabRef, tabWidths, look } = useComputedTabWidth();
    const { offsetItems } = useComputedLeftOffset(tabWidths, contentRef, look);
    const { linePos } = useComputedLinePos(tabWidths, look);
    // 下标线
    const lineRef = useRef<HTMLDivElement | null>(null);
    const { locale } = useRouter();
    /**
     * @desc 监听切换
     */
    useEffect(() => {
        if (look.current) return;

        const toIndex = props.options.findIndex((item) => item.id === props.active);
        // 偏移动画
        if (contentRef.current && toIndex >= 0) {
            const start = contentRef.current.scrollLeft;
            const end = offsetItems.current[toIndex];
            const callback = (value: number) => ((contentRef.current as HTMLElement).scrollLeft = value);
            if (locale === 'sa') {
                // animate({ start: end, end: start, callback });
            } else {
                animate({ start, end, callback });
            }
        }
        // 下标线
        if (lineRef.current) {
            if (toIndex >= 0) {
                if (locale === 'sa') {
                    lineRef.current.style.right = `${linePos.current[toIndex]}px`;
                } else {
                    lineRef.current.style.left = `${linePos.current[toIndex]}px`;
                }
                lineRef.current.style.width = `${tabWidths.current[toIndex]}px`;
            } else {
                if (locale === 'sa') {
                    lineRef.current.style.right = `100%`;
                } else {
                    lineRef.current.style.left = `100%`;
                }
            }
        }
    }, [props.active]);

    const changehandle = (value: string) => props.onChange(value);

    return (
        <section className={`${css.FixedNav}`}>
            <article
                className={`content-fixed-nav fixed ${props.lookPosition ? 'look' : ''}`}
                ref={contentRef}
                style={{ top: locale === 'us' ? '66px' : locale === 'ca' ? '50px' : 0, zIndex: locale === 'us' ? 995 : 2000 }}
            >
                <div className="choose-tab" ref={chooseTabRef}>
                    {props?.options?.map((item, index) => (
                        <div title="tab" className={`tab ${props.active == item.id ? 'active' : ''}`} key={index} onClick={() => changehandle(item.id)}>
                            <div className="name">{item.name}</div>
                            <div className="desc">{item.desc}</div>
                        </div>
                    ))}
                    <div className="line" ref={lineRef}>
                        <span></span>
                    </div>
                </div>
            </article>
        </section>
    );
};

FixedNav.defaultProps = {
    lookPosition: false,
};

export default FixedNav;
